<template>
  <div>
    <div class="desktop faq-switcher-hero">
      <span>자주묻는 질문</span>
    </div>
    <div class="mobile m-faq-switcher-hero">
      <h1>Switcher</h1>
      <p>자주묻는 질문</p>
    </div>
    <b-container>
      <b-row>
        <b-col sm="11" md="8" offset-md="2">
          <div class="faq-wrapper">
            <div class="faq-question" @click="toggle(1)">
              <span class="desktop">Q. 3버튼, 4버튼 혹은 멀티 스위치에 설치가 가능한가요?</span>
              <span class="mobile">Q. 3버튼, 4버튼 혹은 멀티<br>스위치에 설치가 가능한가요?</span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isFirstDropdownOpen}"><img src="@/assets/btn-dropdown-faq.png"></span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isFirstDropdownOpen}">
              <p>스위처는 1버튼, 2버튼 스위치에 부착 가능합니다.<br>
                3구 이상, 토글형, 터치형 스위치에는 사용이 불가합니다.</p>
              <div class="switch-illust-wrapper">
                <div class="switch-illust-container">
                  <img src="@/assets/switcher/1-switch.png" alt="">
                  <div class="illust-text">
                    <img src="@/assets/switcher/illust-check.png" alt="">
                    <span class="available-switch">1버튼 스위치</span>
                  </div>
                </div>
                <div class="switch-illust-container">
                  <img src="@/assets/switcher/2-switch.png" alt="">
                  <div class="illust-text">
                    <img src="@/assets/switcher/illust-check.png" alt="">
                    <span class="available-switch">2버튼 스위치</span>
                  </div>
                </div>
                <div class="switch-illust-container" style="position: relative">
                  <img src="@/assets/switcher/3-switch.png" alt="">
                  <div class="illust-text">
                    <img src="@/assets/switcher/illust-x.png" alt="">
                    <span class="unavailable-switch">3버튼 스위치</span>
                    <p style="font-size: 12px; color:#85888b; position:absolute; left:50%; transform:translateX(-50%);">(출시 예정)</p>
                  </div>
                </div>
                <div class="switch-illust-container">
                  <img src="@/assets/switcher/small-switch.png" alt="">
                  <div class="illust-text">
                    <img src="@/assets/switcher/illust-x.png" alt="">
                    <span class="unavailable-switch">토글형 스위치</span>
                  </div>
                </div>
                <div class="switch-illust-container">
                  <img src="@/assets/switcher/touch-switch.png" alt="">
                  <div class="illust-text">
                    <img src="@/assets/switcher/illust-x.png" alt="">
                    <span class="unavailable-switch">터치형 스위치</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="faq-question" @click="toggle(2)">
              <span class="desktop">Q. 스위처 설치 후, 수동으로 제어할 수 있나요?</span>
              <span class="mobile">Q. 스위처 설치 후,<br>수동으로 제어할 수 있나요?</span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isSecondDropdownOpen}"><img src="@/assets/btn-dropdown-faq.png"></span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isSecondDropdownOpen}">
              <p>물론입니다. 스위처 전면부를 손으로 누르시면 수동으로 불을 켜고 끌 수 있습니다.</p>
            </div>
            <div class="faq-question" @click="toggle(3)">
              <span class="desktop">Q. 벨크로만 별도로 주문이 가능한가요?</span>
              <span class="mobile">Q. 벨크로만 별도로<br>주문이 가능한가요?</span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isThirdDropdownOpen}"><img src="@/assets/btn-dropdown-faq.png"></span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isThirdDropdownOpen}">
              <p>물론입니다. <a href="https://goo.gl/4p1GDM">스토어팜</a> 에서 구입하실 수 있습니다.</p>
            </div>
            <div class="faq-question" @click="toggle(4)">
              <span class="desktop">Q. A/S 문의는 어디로 하나요?</span>
              <span class="mobile">Q. A/S 문의는<br>어디로 하나요?</span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isFourthDropdownOpen}"><img src="@/assets/btn-dropdown-faq.png"></span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isFourthDropdownOpen}">
              <p>1. <a href="https://pf.kakao.com/_uuXmV">카카오톡</a>이 가장 빠릅니다.<br>
              2. 전화주셔도 좋습니다(02-6212-9272)</p>
            </div>
            <div class="faq-question" @click="toggle(5)">
              <span class="desktop">Q. 반납은 어떻게 진행하나요?</span>
              <span class="mobile">Q. 반납은<br>어떻게 진행하나요?</span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isFifthDropdownOpen}"><img src="@/assets/btn-dropdown-faq.png"></span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isFifthDropdownOpen}">
              <p>스위처 어플 내, 스위처 정보에서 반납 신청을 해주시면 수거를 위해 우체국 기사님께서 연락 후에 방문하십니다.<br>반납 택배는 무료입니다.</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: 'switcher-faq',
  data () {
    return {
      isFirstDropdownOpen: false,
      isSecondDropdownOpen: false,
      isThirdDropdownOpen: false,
      isFourthDropdownOpen: false,
      isFifthDropdownOpen: false
    }
  },
  methods: {
    toggle: function (division) {
      switch (division) {
        case 1:
          this.isFirstDropdownOpen = !this.isFirstDropdownOpen
          break
        case 2:
          this.isSecondDropdownOpen = !this.isSecondDropdownOpen
          break
        case 3:
          this.isThirdDropdownOpen = !this.isThirdDropdownOpen
          break
        case 4:
          this.isFourthDropdownOpen = !this.isFourthDropdownOpen
          break
        case 5:
          this.isFifthDropdownOpen = !this.isFifthDropdownOpen
          break
      }
    }
  }
}
</script>
<style>
.faq-switcher-hero {
  background: url("../../../assets/switcher/switcher-faq-hero.png") no-repeat
    center center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  align-items: center;
}
.faq-switcher-hero span {
   font-size: 24px;
   font-weight: bold;
   margin-left: 10%;
}

.m-faq-switcher-hero {
  background: url("../../../assets/switcher/m-switcher-faq-hero.png") no-repeat
    center center;
  background-size: cover;
  min-height: 442px;
  text-align: left;
  padding: 41px 0px 0px 26px;
}

.m-faq-switcher-hero h1 {
  font-size: 18px;
  font-weight: bold;
}
.m-faq-switcher-hero p {
  font-size: 18px;
  margin-top: 25px;
}

.faq-wrapper {
  margin-top: 60px;
  margin-bottom: 60px;
}
.faq-question {
  font-size: 18px;
  padding: 23px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  cursor: pointer;
}
.faq-answer {
  border-top: solid 1px #dee2e5;
  border-bottom: solid 1px #dee2e5;
  padding: 45px;
  display: none;
}
.faq-answer p {
  font-size: 14px;
  margin: 0;
  line-height: 1.56;
  text-align: left;
}
.available-switch {
  font-size: 12px;
  font-weight: 500;
  color: #6f97fa;
}
.unavailable-switch {
  font-size: 12px;
  font-weight: 500;
  color: #fe7578;
}
.switch-illust-wrapper {
  text-align: left;
  margin-top: 20px;
}
.switch-illust-container {
  display: inline-block;
  text-align: center;
  margin-left: 10px;
}

.switch-illust-container .illust-text {
  margin-top: 10px;
}
.open {
  display: block;
  opacity: 1;
}

.dropdown-arrow {
  transition: 0.5s;
}
.dropdown-arrow img {
  width: 21px;
  height: 13px;
}
.showDropDown {
  -webkit-transform: rotate(180deg);
}

  @media only screen and (min-device-width : 320px) and (max-device-width : 568px) {
    .faq-question {
      font-size: 16px;
      padding: 20px;
      text-align: left;
      align-items: center;
    }
    .switch-illust-container {
      margin-top: 20px;
    }
    .switch-illust-container .illust-text {
      margin-top: 5px;
    }
    .dropdown-arrow img {
      width: 18px;
      height: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/products/switcher/SwitcherFaq.vue